import Headers from '@mjackson/headers';
import { applyAdminVendorHeader } from './adminVendorHeader';

type HeaderBuildOptions = {
  headers?: HeadersInit;
  portalCode?: string;
  app?: string;
  accessToken?: string | null;
  refreshToken?: string | null;
  deviceId?: string;
  accept?: string;
  contentType?: string;
  extras?: Record<string, string>;
  skipAdminVendorHeader?: boolean;
};

export const getPortalHeadersByName = (
  portalName?: string,
): { portalCode?: string; app?: string } => {
  switch (portalName) {
    case 'admin':
      return { portalCode: 'erp', app: 'foundation' };
    case 'warehouse':
      return { portalCode: 'erp', app: 'hub' };
    case 'vendor':
      return { portalCode: 'vendor', app: 'nexus' };
    case 'synq':
      return { portalCode: 'erp', app: 'synq' };
    case 'logistics':
      return { portalCode: 'erp', app: 'logistics' };
    default:
      return {};
  }
};

export const SKIP_ADMIN_VENDOR_HEADER = 'x-lk-skip-admin-vendor';

export const buildHeaders = ({
  headers,
  portalCode,
  app,
  accessToken,
  refreshToken,
  deviceId,
  accept = 'application/json',
  contentType = 'application/json',
  extras,
  skipAdminVendorHeader,
}: HeaderBuildOptions): Headers => {
  const nextHeaders = new Headers(headers);
  const skipAdminHeaderFromInput = nextHeaders.get(SKIP_ADMIN_VENDOR_HEADER) === 'true';

  if (accessToken) {
    nextHeaders.set('Authorization', `Bearer ${accessToken}`);
  }
  if (refreshToken) {
    nextHeaders.set('x-lk-refresh-token', refreshToken);
  }
  if (contentType) {
    nextHeaders.set('Content-Type', contentType);
  }
  if (accept) {
    nextHeaders.set('Accept', accept);
  }
  if (deviceId) {
    nextHeaders.set('x-lk-deviceid', deviceId);
  }
  if (portalCode) {
    nextHeaders.set('x-lk-portalcode', portalCode);
  }
  if (app) {
    nextHeaders.set('x-lk-app', app);
  }
  if (extras) {
    Object.entries(extras).forEach(([key, value]) => {
      nextHeaders.set(key, value);
    });
  }

  if (skipAdminHeaderFromInput) {
    nextHeaders.delete(SKIP_ADMIN_VENDOR_HEADER);
  }

  if (skipAdminVendorHeader || skipAdminHeaderFromInput) {
    return nextHeaders;
  }

  return applyAdminVendorHeader(nextHeaders) ?? nextHeaders;
};
